import { render, staticRenderFns } from "./SeatAssignList.vue?vue&type=template&id=1245f334&scoped=true&"
import script from "./SeatAssignList.vue?vue&type=script&lang=js&"
export * from "./SeatAssignList.vue?vue&type=script&lang=js&"
import style0 from "./SeatAssignList.vue?vue&type=style&index=0&id=1245f334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245f334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1245f334')) {
      api.createRecord('1245f334', component.options)
    } else {
      api.reload('1245f334', component.options)
    }
    module.hot.accept("./SeatAssignList.vue?vue&type=template&id=1245f334&scoped=true&", function () {
      api.rerender('1245f334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/SeatAssignList.vue"
export default component.exports